"use client";
import { useState } from "react";

export function RemoveIcon({
  defaultFill = "#5F6368",
  hoverFill = "#FF0000",
  size = 20,
  disabled = false,
}) {
  const [isHovered, setIsHovered] = useState(false);

  const fill = disabled ? "#BDBDBD" : isHovered ? hoverFill : defaultFill;

  return (
    <svg
      width={"16"}
      cursor={disabled ? "default" : "pointer"}
      height={"16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => !disabled && setIsHovered(true)}
      onMouseLeave={() => !disabled && setIsHovered(false)}
      display={"flex"}
      style={{ justifyContent: "center", alignItems: "center" }}
    >
      {!isHovered ? (
        <>
          <path
            d="M5.5 7.48633C5.21604 7.48633 4.98584 7.71652 4.98584 8.00048C4.98584 8.28445 5.21604 8.51464 5.5 8.51464H10.5C10.784 8.51464 11.0142 8.28445 11.0142 8.00048C11.0142 7.71652 10.784 7.48633 10.5 7.48633H5.5Z"
            fill={fill}
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.00146 2.00195C4.68776 2.00195 2.00146 4.68824 2.00146 8.00195C2.00146 11.3157 4.68776 14.002 8.00146 14.002C11.3152 14.002 14.0015 11.3157 14.0015 8.00195C14.0015 4.68824 11.3152 2.00195 8.00146 2.00195ZM3.02978 8.00195C3.02978 5.25617 5.25568 3.03027 8.00146 3.03027C10.7473 3.03027 12.9732 5.25617 12.9732 8.00195C12.9732 10.7477 10.7473 12.9736 8.00146 12.9736C5.25568 12.9736 3.02978 10.7477 3.02978 8.00195Z"
            fill={fill}
          />
        </>
      ) : (
        <path
          d="M8.00049 2C9.59179 2 11.1179 2.63214 12.2431 3.75736C13.3683 4.88258 14.0005 6.4087 14.0005 8C14.0005 9.5913 13.3683 11.1174 12.2431 12.2426C11.1179 13.3679 9.59179 14 8.00049 14C6.40919 14 4.88307 13.3679 3.75785 12.2426C2.63263 11.1174 2.00049 9.5913 2.00049 8C2.00049 6.4087 2.63263 4.88258 3.75785 3.75736C4.88307 2.63214 6.40919 2 8.00049 2ZM5.00049 8C5.00049 8.1364 5.05467 8.26721 5.15112 8.36365C5.24757 8.4601 5.37838 8.51429 5.51477 8.51429H10.4862C10.6226 8.51429 10.7534 8.4601 10.8499 8.36365C10.9463 8.26721 11.0005 8.1364 11.0005 8C11.0005 7.8636 10.9463 7.73279 10.8499 7.63635C10.7534 7.5399 10.6226 7.48571 10.4862 7.48571H5.51477C5.44724 7.48571 5.38036 7.49902 5.31797 7.52486C5.25557 7.55071 5.19887 7.58859 5.15112 7.63635C5.10336 7.6841 5.06548 7.7408 5.03964 7.80319C5.01379 7.86559 5.00049 7.93246 5.00049 8Z"
          fill={fill}
        />
      )}
    </svg>
  );
}
